import React, { useState } from "react";
import { Link } from "react-router-dom";
import { deleteMyInsightData } from "../utils/insights";
import "./Privacy.css";

const copy = {
  ko: {
    title: "개인정보 처리방침", effective: "시행일: 2026년 8월 1일", back: "← COOLDOC",
    sections: [
      ["1. 수집하는 개인정보", "COOLDOC은 회원가입을 요구하지 않으며 실명, 전화번호, 정확한 생년월일, 주소를 입력받지 않습니다. 검사 답변과 결과 점수는 기본적으로 사용자의 브라우저 또는 앱 기기에 저장됩니다."],
      ["2. 자동 생성 정보", "서비스 접속 과정에서 보안과 안정적인 운영을 위해 접속 시각, IP 주소, 브라우저·기기 정보와 같은 일반적인 서버 기록이 호스팅 제공자를 통해 처리될 수 있습니다. 이 정보는 개인 성향 결과를 식별하거나 광고 프로필을 만드는 데 사용하지 않습니다."],
      ["3. 이용 목적과 보유", "기기에 저장된 검사 정보는 진행 상태 복원과 결과 표시를 위해 사용됩니다. 사용자는 아래 삭제 버튼 또는 브라우저·앱의 저장공간 삭제 기능으로 언제든 삭제할 수 있습니다. 보안 서버 기록은 서비스 보호에 필요한 기간 동안만 보관됩니다."],
      ["4. 제3자 제공과 계정", "COOLDOC은 검사 결과를 제3자에게 판매하지 않습니다. 검사 이용을 위해 Google, Apple 또는 별도의 COOLDOC 계정 로그인을 요구하지 않습니다."],
      ["5. 아동 및 문의", "보호자가 필요한 연령의 사용자는 보호자와 함께 이용해 주세요. 개인정보, 삭제 또는 서비스 관련 문의는 cooldoclab@gmail.com으로 보내주세요."]
    ],
    delete: "이 기기의 COOLDOC 데이터 삭제", deleting: "삭제 중...", deleted: "이 기기에 저장된 COOLDOC 검사 데이터를 삭제했습니다."
  },
  en: {
    title: "Privacy Policy", effective: "Effective: August 1, 2026", back: "← COOLDOC",
    sections: [
      ["1. Personal information", "COOLDOC does not require account creation and does not ask for a legal name, phone number, exact date of birth, or street address. Test answers and result scores are stored by default in the user's browser or app device."],
      ["2. Automatically generated information", "Standard server records such as access time, IP address, browser, and device information may be processed by our hosting provider for security and reliable operation. We do not use this information to identify personality results or build advertising profiles."],
      ["3. Purpose and retention", "Information stored on the device is used to restore progress and display results. It can be removed at any time with the button below or by clearing browser/app storage. Security logs are retained only as needed to protect the service."],
      ["4. Sharing and accounts", "COOLDOC does not sell test results to third parties. A Google, Apple, or separate COOLDOC account is not required to take the test."],
      ["5. Children and contact", "Users who require a guardian should use the service with one. For privacy, deletion, or service questions, contact cooldoclab@gmail.com."]
    ],
    delete: "Delete COOLDOC data on this device", deleting: "Deleting...", deleted: "COOLDOC test data stored on this device has been deleted."
  }
};

const Privacy = () => {
  const [status, setStatus] = useState("");
  const lang = localStorage.getItem("cooldoc_lang") === "ko" ? "ko" : "en";
  const text = copy[lang];
  const removeData = async () => {
    setStatus(text.deleting);
    try { await deleteMyInsightData(); } catch (_) {}
    ["cooldoc_scores", "cooldoc_result_depth", "cooldoc_name", "cooldoc_checkpoint_ready", "cooldoc_profile"].forEach((key) => localStorage.removeItem(key));
    setStatus(text.deleted);
  };
  return <div id="top-container" className="privacy-bg"><main className="privacy-page">
    <Link className="privacy-back" to="/">{text.back}</Link>
    <h1>{text.title}</h1><p className="privacy-updated">{text.effective}</p>
    {text.sections.map(([title, body]) => <section key={title}><h2>{title}</h2><p>{body}</p></section>)}
    <button className="privacy-delete" onClick={removeData}>{text.delete}</button>
    {status && <p className="privacy-status" role="status">{status}</p>}
  </main></div>;
};
export default Privacy;
